import { IConfig } from '../types';

const env = process.env.NODE_ENV;

const getIsUPC = () => {
  const isLocalUPC =
    env === 'development' && process.env.REACT_APP_ENV === 'upc';
  return window.location.pathname.substring(1, 4) === 'upc' || isLocalUPC;
};

const getCountryCode = () => {
  const isLatam = getIsUPC()
    ? window.location.pathname.substring(5, 7) === 'of'
    : window.location.pathname.substring(1, 3) === 'of';

  if (env === 'development') {
    return 'us';
  } else if (isLatam) {
    return 'ofertas';
  }

  return getIsUPC()
    ? window.location.pathname.substring(5, 7)
    : window.location.pathname.substring(1, 3);
};

const getOCAPIHost = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'store-staging.ubi.com';
  }

  return window.location.host;
};

const getLang = () => document.documentElement.getAttribute('lang');

const CONFIG: IConfig = {
  isUPC: getIsUPC(),
  countryCode: getCountryCode(),
  lang: getLang(),
  apiHost: getOCAPIHost(),
  targetSpaceIds: [
    '3f28fbeb-1eaa-460f-9265-2ef2a47fd152',
    'e17be87d-2996-4f3b-97c4-19bb2dae2933'
  ]
};
export default CONFIG;
